import React from 'react';
import Language from '../../Language.data.js';
import Link from '../../Link.component';

function Facebook(props) {
    return (
        <>
            <div className="row mt-2" id="facebook">
                <div className="col text-justify font-weight-bold">
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebook
                    }
                </div>
            </div>
            <div className="row mt-1">
                <div className="col text-justify">
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText1
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/policy" 
                        target="_blank"
                    />
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText2
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/policy" 
                        target="_blank"
                    />
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText3
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/legal/terms/page_controller_addendum" 
                        target="_blank"
                    />
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText4
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/legal/terms/information_about_page_insights_data" 
                        target="_blank"
                    />.
                    <br />
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText5
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/about/privacy" 
                        target="_blank"
                    />.

                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText6
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/legal/EU_data_transfer_addendum" 
                        target="_blank"
                    />
                    {
                        Language[props.selectedLanguage].privacyTexts.facebook.facebookText7
                    }
                    <Link 
                        linkUrl="https://www.facebook.com/legal/terms/information_about_page_insights_data" 
                        target="_blank"
                    />.
                </div>
            </div>
        </>
    )
}

export default Facebook;